/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Reset_TitleInputs */



/**
* | output |
* | --- |
* | "Reset your password" |
*
* @param {Login_Reset_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const login_reset_title = /** @type {((inputs?: Login_Reset_TitleInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Reset_TitleInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Réinitialisez votre mot de passe")
	if (locale === "es") return /** @type {LocalizedString} */ ("Restablecer su contraseña")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Redefina sua senha")
	if (locale === "it") return /** @type {LocalizedString} */ ("Reimposta la tua password")
	return /** @type {LocalizedString} */ ("Reset your password")
});